import { Injectable } from '@angular/core';
import {DataService} from './data.service';
import {of, ReplaySubject} from 'rxjs';
import {SummaryElement} from '../models/voice-bot.model';

@Injectable({
  providedIn: 'root'
})
export class CrawlerService {
  private MOCK_CRAWLER = false;
  private _activeCrawler$ = new ReplaySubject<boolean>(1);
  public activeCrawler$ = this._activeCrawler$.asObservable();
  private _summary$ = new ReplaySubject<SummaryElement[]>(1);
  public summary$ = this._summary$.asObservable();

  constructor(private dataService: DataService) {  }

  public initCrawler(website: string, email: string) {
    if (!website || !email) {
      return;
    }
    this._activeCrawler$.next(true);

    if (this.MOCK_CRAWLER) { // TODO OUT
      this.mockedSummary$().subscribe((summary) => {
        this._activeCrawler$.next(false);
        this._summary$.next(summary);
      });
    } else {
      this.dataService.crawlWebsite(website, email).subscribe((summary) => {
        this._activeCrawler$.next(false);
        this._summary$.next(summary);
      });
    }



  }

  private mockedSummary$() {
    const a = [
      {
        "content": "Willkommen bei den Berlin Flamingos",
        "title": "Zusammenfassung der Informationen über die Berlin Flamingos",
        "subtitles": [
          {
            "subtitle": "Willkommen bei den Berlin Flamingos",
            "content": "Die Berlin Flamingos sind Berlins und Ostdeutschlands größter und mitgliederstärkster Baseballverein. Seit 1990 bieten die Flamingos ein umfangreiches Programm für alle Altersklassen an, sowohl für Anfänger als auch für Fortgeschrittene, und sie ermöglichen das Spielen von Softball."
          },
          {
            "subtitle": "Nächstes Heimspiel",
            "content": "Datum: Samstag, 10. Mai 2025\nUhrzeit: 12:00 Uhr\nGegner: Nicht spezifiziert, aber es handelt sich um ein Heimspiel in der zweiten Bundesliga."
          },
          {
            "subtitle": "Aktuelle Beiträge",
            "content": "Die Seite enthält die acht neusten Beiträge, darunter:\n- Saisonstarts und Vorbereitungen auf die neue Saison.\n- Siege in der 2. Bundesliga Nord.\n- Neuigkeiten über Teamverstärkungen, wie „Die Steinreiniger\".\n- Informationen über die Halbfinalserie, die gegen die 89ers gewonnen wurde.\n- Das jährliche Flamingos FUNTeam Slowpitch Turnier am 14./15. September.\n- Anmeldungen für das Flamingos-Sommercamp sind nun aktiv."
          },
          {
            "subtitle": "Baseball und Softball Angebote",
            "content": "Die Berlin Flamingos bieten in allen Altersklassen mindestens eine Mannschaft, was eine Vielzahl von Möglichkeiten für Interessierte schafft."
          },
          {
            "subtitle": "Online-Fanshop",
            "content": "Die Flamingos haben einen Online-Fanshop bei Diamond Pride eröffnet, der eine breite Palette an Merchandise-Artikeln anbietet:\n- T-Shirts\n- Hoodies\n- Jacken\n- Verschiedene Größen und Layouts\n- Merchandising auch für das Softball-Team."
          },
          {
            "subtitle": "Kontakt und Informationen",
            "content": "Die neuesten Informationen über die Berlin Flamingos können über deren sozialen Medienkanäle abgerufen werden."
          },
          {
            "subtitle": "Fazit",
            "content": "Die Berlin Flamingos stellen eine bedeutende Institution im Baseballsport dar, und ihre Engagements umfassen sowohl den Schulsport als auch Freizeitaktivitäten für Baseball- und Softball-Enthusiasten in Berlin."
          }
        ]
      },
      {
        "content": "News über die Berlin Flamingos",
        "title": "News",
        "subtitles": [
          {
            "subtitle": "Saisonstart und wichtige Termine",
            "content": "Die Saison startet bald, und die Fans werden auf das neue Team eingestimmt. Details über die Spieltage werden in Kürze veröffentlicht. Das Flamingos FUNTeam Slowpitch Turnier findet am 14. und 15. September statt. Interessierte sind eingeladen, vorbeizukommen und Teil des Turniers zu werden."
          },
          {
            "subtitle": "Teamleistungen und Erfolge",
            "content": "Die Berlin Flamingos haben die Meisterschaft der 2. Baseball-Bundesliga Nord „dramatic fashion“ gewonnen. In einem spannenden Finale mussten sie einen Rückstand überwinden, um den Titel zu sichern.\nDie Bremen Dockers gewannen am vorhergehenden Wochenende mit 12-2 in Spiel 1 des Halbfinals. Die Flamingos konnten die Halbfinalserie gegen die 89ers klar mit 2-0 gewinnen."
          },
          {
            "subtitle": "Neue Mitglieder und Anmeldungen",
            "content": "Die Flamingos freuen sich, „Die Steinreiniger“ in ihrem Team willkommen zu heißen. Diese Mitgliedschaft wird das Team stärken.\nAb sofort ist die Anmeldung für das Sommercamp geöffnet. Hier werden alle interessierten Baseball-Fans sowie Neulinge herzlich eingeladen, sich zu registrieren."
          },
          {
            "subtitle": "Verbandsinformationen",
            "content": "Für eine umfassende Information über das Spielprogramm und die Aktivitäten können die offiziellen Seiten der Verbände aufgerufen werden: DBV (Deutscher Baseball Verband), BSVBB (Baseball- und Softballverband Berlin/Brandenburg). Insgesamt zeigen die Berlin Flamingos eine engagierte Ambition zur Förderung des Baseballsports in der Region durch ihre Teilnahme an Wettkämpfen und die Ansprache neuer Mitglieder."
          }
        ]
      },
      {
        "content": "Der Verein: Berlin Flamingos",
        "title": "Der Verein",
        "subtitles": [
          {
            "subtitle": "Vereinsstruktur",
            "content": "Die Berlin Flamingos e.V. sind ein Baseball- und Softballverein, der seit dem 20. September 2011 eigenständig ist. Ursprünglich als Frohnau Flamingos im Jahr 1990 gegründet, bietet der Verein Aktivitäten für ca. 220 Mitglieder in verschiedenen Altersklassen und Erfahrungsstufen an. Der Verein ist im Märkischen Viertel in Berlin ansässig und nimmt mit insgesamt neun Mannschaften am Spielbetrieb des Deutschen Baseball und Softballverbandes (DBV) sowie des Berliner Baseball- und Softballverbandes (BSVBB) teil.\nDie Struktur des Vereins umfasst folgende Schlüsselpositionen:\n- 1. Vorsitzender: Marcel Dieck\n- 2. Vorsitzende: Martina Wägner\n- Kassenwart: Reiner Wöttke\n- Jugendwartin: Birgitt Blesing.\nVereinsadresse: Berlin Flamingos e.V. c/o Reiner Wöttke Nordhellesteig 3a 13507 Berlin."
          },
          {
            "subtitle": "Bankverbindung",
            "content": "Bank: Deutsche Kreditbank AG\nBLZ: 120 300 00\nKonto: 10 200 350 67\nIBAN: DE 32120300001020035067\nBIC: BYLADEM1001."
          },
          {
            "subtitle": "Trainingszeiten im Flamingo Park",
            "content": "Der Flamingo Park ist der Trainingsort des Vereins, bestehend aus einer Sportanlage im Märkischen Viertel. Während der Sommersaison, die am 1. April beginnt, finden die Trainings zu den folgenden Uhrzeiten statt:\n- Superminis U4: Dienstags und donnerstags 16:00 - 16:30 Uhr\n- Teeballer: Dienstags und donnerstags 16:30 - 18:30 Uhr\n- Schülermannschaften: Montags und mittwochs 17:00 - 19:00 Uhr\n- Junioren: Montags und mittwochs 18:00 - 20:00 Uhr\n- Trainings für die Teams 2 und 3: Montags und mittwochs 20:00 - 21:45 Uhr\n- Frauen- und Mädchen-Softball: Dienstags und donnerstags 17:00 - 18:30 Uhr\n- Funteam: Freitags 18:00 - 20:00 Uhr."
          },
          {
            "subtitle": "Umpire und Scorer",
            "content": "Der Verein ist auf der Suche nach engagierten Umpires und Scorern, welche die Spiele leiten und protokollieren. Interessierte, die mindestens 14 Jahre alt sind, können sich an folgende Ansprechpartner wenden:\n- Umpire Ansprechpartner: Oskar Podszus\n- Scorer Ansprechpartnerin: Anna-Lena Podszus. Das Umpiring und Scoring sind wesentliche Teile des Spielbetriebs und bieten die Möglichkeit, aktiv am Geschehen mitzuwirken."
          },
          {
            "subtitle": "FlaminGOschool",
            "content": "Mit dem FlaminGOschool-Projekt, das 2016 in Berliner Grundschulen eingeführt wurde, wird Kindern, die sich für Baseball interessieren, eine kostenlose und umfangreiche Möglichkeit geboten, den Sport zu erlernen. Das Programm umfasst:\n- 10 Wocheneinheiten à 90 Minuten.\n- Aufteilung in Altersstufen: 1.-3. Klasse und 4.-6. Klasse.\n- Bereitstellung von Baseball-Ausrüstung für die Teilnehmer.\nDie Schul-AGs enden jedes Halbjahr mit einem Turnier, bei dem die Kinder ihre Fertigkeiten im sportlichen Wettkampf zeigen können."
          },
          {
            "subtitle": "Merchandise",
            "content": "Der Fanshop der Flamingos bietet eine breite Palette an Merchandise-Artikeln, darunter:\n- T-Shirts\n- Hoodies\n- Jacken.\nDiese Produkte sind in verschiedenen Größen und Layouts erhältlich, um sicherzustellen, dass jeder Fan etwas Passendes findet. Individualisierbare Trikots und Trainingskleidung sind ebenfalls verfügbar."
          },
          {
            "subtitle": "Kids Korner",
            "content": "Der Kids Korner richtet sich an die jüngsten Mitglieder des Vereins und bietet kreative Spiele und Aktivitäten rund um den Baseballsport. Ausmalvorlagen und Bastelprojekte werden bereitgestellt, um den Kindern eine unterhaltsame Möglichkeit zu bieten, sich mit dem Sport zu beschäftigen und ihn zu fördern."
          }
        ]
      },
      {
        "content": "Flamingo TV – Berlin Flamingos",
        "title": "Flamingo TV",
        "subtitles": [
          {
            "subtitle": "Streamingangebot",
            "content": "Flamingo TV bietet seit 2016 die Möglichkeit, Heimspiele der Berlin Flamingos in HD zu streamen. Diese Übertragungen richten sich an Fans, die nicht im Flamingo Park sein können. Eine Vielzahl von Video-Inhalten, darunter das Vereinsmagazin „Inside Pitch“, ergänzt das Live-Streaming."
          },
          {
            "subtitle": "Technische Details",
            "content": "Der Livestream ist für viele Fans oft die einzige Gelegenheit, Spiele visuell zu verfolgen, da einige Bundesligisten ebenfalls Internet-TV-Angebote betreiben. Das Flamingos.TV-Team beginnt 2 bis 2,5 Stunden vor dem ersten Pitch. Die ersten Schritte bestehen im Aufbau der Kameras und der technischen Einstellungen, gefolgt von Feinabstimmungen in der Audio- und Bildqualität.\n- Verantwortlicher für Technik, Kameras und Ton: Reiner Wöttke, Spielerfahrung: fast 25 Jahre.\n- Kommentatoren-Team: Steve Meißner, Samanta Thomas, Joachim Lißner, David Kania, Christian Sengeleitner (hauptsächlich für Moderation zuständig)."
          },
          {
            "subtitle": "Übertragungsprozess",
            "content": "Presseformate wie XXL-Scoresheets werden vorbereitet. Eine halbe Stunde vor dem Spiel werden die offiziellen Lineups kommuniziert. Die Live-Übertragung beginnt 15 Minuten vor Spielbeginn."
          },
          {
            "subtitle": "Zuschauerinteraktion",
            "content": "Das Kommentatoren-Team legt großen Wert auf sachliche Berichterstattung und genießt es, das Spiel zu begleiten. Zuschauerfeedback wird geschätzt, und es gibt die Möglichkeit, während der Übertragungen über soziale Medien Kontakte herzustellen. Zuschauer haben Zugang zu einem Archiv vergangener Spiele und können verpasste Spiele jederzeit als „Konserve“ ansehen."
          },
          {
            "subtitle": "Motivation und Ziele",
            "content": "Nach dem ersten Jahr im Oberhaus des Deutschen Baseballs blickt das Team optimistisch in die Zukunft und setzt auf qualitative Bild- und Tonübertragungen sowie einen lebendigen Kommentierungsstil. Obwohl man stolz auf die eingeschlagene Richtung ist, wird betont, dass ein Live-Besuch im Flamingo Park unvergleichlich bleibt."
          },
          {
            "subtitle": "Kontakt",
            "content": "Fans sind eingeladen, sich aktiv an den Übertragungen zu beteiligen und Feedback zu geben."
          }
        ]
      },
      {
        "content": "Die Teams der Berlin Flamingos",
        "title": "Die Teams",
        "subtitles": [
          {
            "subtitle": "Übersicht der Teams",
            "content": "Die Berlin Flamingos sind ein sportlicher Verein, der sowohl Baseball als auch Softball anbietet. Die Teams sind in verschiedenen Ligen aktiv und bieten eine Vielzahl von Möglichkeiten für Spieler jeden Alters und Erfahrungsgrades. Die Hauptmannschaft, die 2025 in der 2. Bundesliga spielt, hat unter dem Coaching von Maikel Azcuy, Nico Kannapinn, Tristan Hoffmann und Rafael ihr Team zusammengestellt. Der Heimspielplan 2025 (2. Bundesliga Nordost) umfasst Spiele gegen die Braunschweig 89ers, Berlin Roadrunners, Hannover Regents und Berlin Skylarks. Alle Heimspiele finden samstags ab 12:00 Uhr im Flamingo Park statt. Die Zweite und Dritte Mannschaft haben jeweils ihre eigenen Eigenschaften und Ziele in der Landesliga."
          },
          {
            "subtitle": "Nachwuchsteams",
            "content": "Die Nachwuchsarbeit ist ein zentraler Bestandteil des Vereins, um sicherzustellen, dass für jede Altersklasse Angebote bereitstehen. Die Einteilung erfolgt wie folgt: T-Baller (U8), Schüler (U12), Jugend (U15) und Junioren (U18)."
          },
          {
            "subtitle": "Trainerstab für 2024",
            "content": "Der Trainerstab ist aufgeteilt nach Altersgruppen:\n- T-Ball: Head Coach: Sven Müller, Betreuerinnen: Silke Müller, Paula Matjes\n- Toss-Ball: Team 1: Head Coach: Michael Blesing, Assistant Coach: Lyubomir Zanev; Team 2: Head Coach: Birgitt Blesing, Assistant Coach: Dominik Knaak\n- Schüler: Head Coach: Jenny Schulz\n- Jugendaufbau und -trainer: Head Coach: Alexis Linares Paez\n- Junioren: Head Coach: Walter Sacasa."
          },
          {
            "subtitle": "Softball",
            "content": "Die Softball-Abteilung wurde nach einer Pause wiederbelebt. Der Verein spielt nun wieder im Softball und bildet eine Spielgemeinschaft mit den Potsdam Porcupines. Die Mannschaft ist unter dem Coaching von Andreas Kick und Dennis Seele aktiv. In der Saison 2022 trat das Team in der Berlin-Brandenburger Verbandsliga an."
          },
          {
            "subtitle": "Unser Funteam",
            "content": "Das Funteam ist ein lockeres, gemischtes Team von Spielerinnen und Spielern jeden Alters. Es bietet eine unterhaltsame Möglichkeit, Softball zu spielen, insbesondere für weniger erfahrene Personen. Dieses Team spielt Slowpitch-Softball und fokussiert sich auf den Spaß am Spiel. Regelmäßige Trainings finden statt, ergänzt durch Freundschaftsspiele und ein eigenes Turnier im Flamingo Park im September. Der Spaß steht dabei im Vordergrund und alle Interessierten sind herzlich eingeladen, mitzumachen."
          }
        ]
      },
      {
        "content": "Sponsoring der Berlin Flamingos",
        "title": "Sponsoring",
        "subtitles": [
          {
            "subtitle": "Fakten über die Berlin Flamingos",
            "content": "Gründung: 1990. Teamanzahl: 11 Mannschaften. Zielgruppe: Kinder und Jugendliche aus allen sozialen Kontexten. Auswahlmannschaften: Jedes Jahr haben besonders talentierte junge Spieler die Möglichkeit, in Auswahlmannschaften berufen zu werden."
          },
          {
            "subtitle": "Über Uns",
            "content": "Organisation: Berlin Flamingos e.V. Typ: Hauptstadtbaseball. Das Engagement der Berlin Flamingos für die Gemeinschaft und den Baseballsport bietet eine wertvolle Plattform für junge Talente und sportbegeisterte Menschen, unabhängig von ihrem sozialen Hintergrund."
          }
        ]
      }
    ];
    return of(a);
  }
}
